const colors = {
    "darkPurple": "#1E1B37",
    "purple": "#626EEB",
    "lightPurple": "#9E8CFF",
    "pink": "#FF71BC",
    "peach": "#f5dcdc",
    "orangePeach": "#FF7F56",
    "white": "#FFFFFF",
    "black": "#0B090B",

    // darkPurple: "#240432",
    // purple: "#5A257D",
    // lightPurple: "#8543D9",
    // extraLightPurple: "#C5C5FD",
    // darkPink: "#DA80C0",
    // pink: "#F77E93",
    // lightPink: "#EA5B94",
    // peach: "#F5F2DC",
    // orangePeach: "#FFC0A4",
    // white: "#F3FCF0",
    // black: "#0B090B",
}

export default colors